import React from "react";
import { Box } from "@mui/material";
import { Routes, Route } from "react-router-dom";

import { NavBar } from "./components";
import Home from "./pages/Home";
import VirtuFit from "./pages/VirtuFit";
import Orchestrix from "./pages/Orchestrix";

const App = () => {
  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#0b1120" }}>
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects/virtufit" element={<VirtuFit />} />
        <Route path="/projects/orchestrix" element={<Orchestrix />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </Box>
  );
};

export default App;
